/** Sichtbares Element mit `data-tour`. Versteckte Doppel (Desktop/Mobil) werden übersprungen. */
export function findTourTarget(target: string): HTMLElement | null {
  const selector = `[data-tour="${CSS.escape(target)}"]`;
  const nodes = document.querySelectorAll<HTMLElement>(selector);
  for (const el of nodes) {
    const style = window.getComputedStyle(el);
    if (style.display === "none" || style.visibility === "hidden") continue;
    const rect = el.getBoundingClientRect();
    if (rect.width < 2 || rect.height < 2) continue;
    return el;
  }
  return null;
}
